export const EMAIL_REGEX = /[a-z0-9A-Z-_+]+(\.[a-z0-9A-Z-_+]+)*@[a-z0-9A-Z-_]+(\.[a-z0-9A-Z-_]+).[a-zA-Z]+/;
